import { takeEvery, call, put, all, fork, select } from "redux-saga/effects";
import { Alert } from "react-native";
import {
  SAVE_PASSWORD,
  DELETE_PROFILE,
  PASSWORD_HAVE_BEEN_CHANGED,
  PASSWORD_HAVE_NOT_BEEN_CHANGED,
  actionCreators,
} from "./action";
import reduxSagaFirebase from "../../common/reduxSagaFirebase";
import { Platform } from "react-native";
import { actionCreators as actionCreatorsForgotPassword } from "../ForgotPassword/action";
import { actionCreators as actionCreatorsSpinner } from "./../Spinner/action";
import {tSaga} from "../../translations";

const modal = (redirect, language) => {

  if (Platform.OS === "web") {
    if (
      confirm(
        tSaga('removeAccount_verification_message', language),
      ) == true
    ) {
      redirect();
    }
  } else {
    Alert.alert(
      tSaga('removeAccount_sign_in_for_remove_message_one', language),
      tSaga('removeAccount_sign_in_for_remove_message_two', language),
      [
        {
          text: tSaga('removeAccount_choices_cancel', language),
          onPress: () => {},
        },
        {
          text: tSaga('removeAccount_choices_okay', language),
          onPress: () => {
            redirect();
          },
        },
      ]
    );
  }
};

const confirmedModal = (redirect, language) => {

  if (Platform.OS === "web") {
    alert(
      tSaga('removeAccount_accountDeleted_message', language),
    );
    redirect();
  } else {
    Alert.alert(
      tSaga('removeAccount_accountDeleted_else_message_one', language),
      tSaga('removeAccount_accountDeleted_else_message_two', language),
      [
        {
          text: tSaga('removeAccount_accountDeleted_text', language),
          onPress: () => {
            redirect();
          },
        },
      ]
    );
  }
};

function* onSavePasswordSaga(action) {



  try {
    const email = yield select((state) => state.user.user.email);
    const password = action.payload.password;
    const oldPassword = action.payload.oldPassword;
    yield put(actionCreatorsSpinner.showSpinner());
    yield call(
      reduxSagaFirebase.auth.signInWithEmailAndPassword,
      email,
      oldPassword
    );
    yield call(reduxSagaFirebase.auth.updatePassword, password);
    yield put(actionCreators.passwordHaveBeenChanged());
    yield put(actionCreatorsSpinner.hideSpinner());
  } catch (error) {
    yield put(actionCreators.passwordHaveNotBeenChanged(error));
    yield put(actionCreatorsSpinner.hideSpinner());
  }
}

function* onDeleteProfileSaga({ payload }) {

  const language = yield select((state) => state.language);
  
  const redirect = payload.redirect;
  try {
    yield put(actionCreatorsSpinner.showSpinner());
    yield call(reduxSagaFirebase.auth.deleteProfile);
    confirmedModal(redirect, language);
    yield put(actionCreators.profileHaveBeenDeleted());
    yield put(actionCreatorsSpinner.hideSpinner());
  } catch (error) {
    modal(redirect, language);
    yield put(actionCreators.profileHaveNotBeenDeleted(error));
    yield put(actionCreatorsSpinner.hideSpinner());
  }
}

function* onPasswordHaveBeenChangedSaga() {
  const language = yield select((state) => state.language);
  alert(tSaga('editProfilePage_passwordChanged_message', language));
}

function* onPasswordHaveNotBeenChangedSaga(action) {
  yield put(actionCreatorsForgotPassword.saveErrorReponse(action.payload));
  // alert(`Hasło nie zostało zmienione. ${checker(payload.code)}`);
}

function* savePasswordSaga() {
  yield takeEvery(SAVE_PASSWORD, onSavePasswordSaga);
}

function* passwordHaveBeenChangedSaga() {
  yield takeEvery(PASSWORD_HAVE_BEEN_CHANGED, onPasswordHaveBeenChangedSaga);
}

function* passwordHaveNotBeenChangedSaga() {
  yield takeEvery(
    PASSWORD_HAVE_NOT_BEEN_CHANGED,
    onPasswordHaveNotBeenChangedSaga
  );
}

function* deleteProfileSaga() {
  yield takeEvery(DELETE_PROFILE, onDeleteProfileSaga);
}

export function* editProfileSaga() {
  yield all([
    fork(savePasswordSaga),
    fork(deleteProfileSaga),
    fork(passwordHaveBeenChangedSaga),
    fork(passwordHaveNotBeenChangedSaga),
  ]);
}
